/*eslint-disable */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GoogleMap } from '@angular/google-maps';
import { ValidatorService } from '../../../survey/services/validator.service';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-gmap',
  templateUrl: './gmap.component.html',
  styleUrls: ['./gmap.component.scss'],
})
export class GmapComponent extends BaseComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() readonly = false as boolean;
  @Input() showForm = false as boolean;
  @Input() showMap = true as boolean;
  @Input() selected = null;
  @Input() polygons: any[] = [];
  @Output() selectedChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: ElementRef;
  @ViewChild(GoogleMap) map: GoogleMap;
  loaded = false;
  form: FormGroup;

  config = {
    streetViewControl: false,
    mapTypeControl: false,
    disableDefaultUI: true,
    fullscreenControl: true,
    zoomControl: true,
  };

  markerConfig = {} as google.maps.MarkerOptions;
  zoom = 12;
  center = { lat: -33.4489, lng: -70.6693 };
  isNew = true;

  constructor(
    private changesDetector: ChangeDetectorRef,
    public renderer: Renderer2,
    public formBuilder: FormBuilder,
    public validatorService: ValidatorService,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
     if (changes.selected) {
       this.selected = changes.selected.currentValue;
      this.fillInitMap();
    }
  }

  ngOnInit(): void {
    // if (this.selected !== undefined && this.selected !== null) {
    //   this.isNew = Object.keys(this.selected).length != 0;
    // }
     this.buildForm();
     this.fillInitMap();
  }

   buildForm() {
    this.form = this.formBuilder.group({
      place: ['', [Validators.required]],
    });
    this.subscription.add(
      this.form.controls.place.valueChanges.pipe().subscribe((_place) => {
        this.checkPlace(_place);
      })
    );
  }

  checkPlace = (_place) => {
    if(this.selected){
      const isSelected = this.selected.formattedAddress == _place;
      if (isSelected) {
        this.form.controls.place.setErrors(null);
        this.changesDetector.detectChanges();
        this.form.updateValueAndValidity();
      } else {
        this.form.controls.place.setErrors({ invalidPlace: true });
        this.changesDetector.detectChanges();
        this.form.updateValueAndValidity();
      }
    }
  };

  ngAfterViewInit() {
    this.initData();
  }

  initData() {
    if (this.readonly) {
      this.markerConfig = { draggable: false };
      return;
    }

    this.markerConfig = { draggable: true };
    const searchBox = new google.maps.places.SearchBox(
      this.addresstext.nativeElement
    );
    
    // Configurar búsqueda para Chile
    const options = {
      componentRestrictions: { country: 'cl' }, // Restricción a Chile
    };
    
    // Usar Autocomplete en lugar de SearchBox para mayor control
    const autocomplete = new google.maps.places.Autocomplete(
      this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'cl' },
        fields: ['address_components', 'geometry', 'formatted_address', 'name'],
        types: ['establishment', 'geocode'] // Permitir direcciones y establecimientos
      }
    );
    // this.buildLocation();

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      
      // Centrar el mapa en la ubicación seleccionada
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      } else {
        this.map.googleMap?.setCenter(place.geometry.location);
        this.map.googleMap?.setZoom(15);
      }
      
      this.selected = this.getAddressObject(place);
      this.checkPlace(place.formatted_address);
      this.selectedChange.emit(this.selected);
      this.changesDetector.detectChanges();
    });

    this.addresstext.nativeElement.addEventListener('input', (event) => {
      if (
        !(event.target.value && event.target.value.toString().trim().length > 0)
      ) {
        this.selected = {};
        this.selectedChange.emit(this.selected);
      }
    });
  }

  buildLocation() {
    if (this.selected && this.selected?.location) {
      let text;
      if (this.selected?.name)
        text = `${this.selected.name} - ${this.selected.formattedAddress}`;
      else text = `${this.selected.formattedAddress}`;
      this.addresstext.nativeElement.value = text;
      const bounds = new google.maps.LatLngBounds();
      bounds.union(this.selected?.viewport);
      this.map.fitBounds(bounds);
    }
  }

  fillInitMap() {
    if (this.selected && this.selected.location) {
      this.center = {
        lat: +this.selected.location.lat,
        lng: +this.selected.location.lng,
      };

      if(this.form){
        this.form.controls.place.setValue(this.selected.formattedAddress);
      }
    }
  }

  getAddressObject(place: google.maps.GeocoderResult | google.maps.places.PlaceResult) {
    const address_components = place.address_components;
    const ShouldBeComponent = {
      streetNumber: ['street_number'],
      postalCode: ['postal_code'],
      street: ['street_address', 'route'],
      suburb: ['neighborhood', 'political'],
      state: [
        'administrative_area_level_1',
        'administrative_area_level_2',
        'administrative_area_level_3',
        'administrative_area_level_4',
        'administrative_area_level_5',
      ],
      city: [
        'locality',
        'sublocality',
        'sublocality_level_1',
        'sublocality_level_2',
        'sublocality_level_3',
        'sublocality_level_4',
      ],
      country: ['country'],
    };
    const address = {
      name: (place as google.maps.places.PlaceResult)?.name || null,
      country: null,
      state: null,
      city: null,
      suburb: null,
      street: null,
      postalCode: null,
      streetNumber: null,
      location: place.geometry.location.toJSON(),
      viewport: place.geometry.viewport.toJSON(),
      formattedAddress: place.formatted_address,
    };
    address_components.forEach((component) => {
      for (const shouldBe in ShouldBeComponent) {
        if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
          address[shouldBe] = component.long_name;
        }
      }
    });
    return address;
  }

   geocodeLatLng(_event: google.maps.MapMouseEvent) {
    this.selected.location = _event.latLng.toJSON();
    let latlng = new google.maps.LatLng(
      this.selected.location.lat,
      this.selected.location.lng
    );
    // This is making the Geocode request
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        alert(status);
      }
      // This is checking to see if the Geoeode Status is OK before proceeding
      if (status == google.maps.GeocoderStatus.OK) {
        // this.place = results[0].formatted_address;

        this.selected = this.getAddressObject(results[0]);
        this.selectedChange.emit(this.selected);
      }
    });
  }
}
